import { useOutletContext } from 'react-router-dom'

import { Box, Text } from '@factorialco/deprecated-design-system'
import { ComplaintsDataCollectionItemFragment } from 'generated/resources/graphql'

import i18n from 'modules/core/lib/i18n'

import Feed from './Feed'
import NewMessage from './NewMessage'

interface OutletContext {
  complaint: ComplaintsDataCollectionItemFragment
}

const ComplaintActivity: React.FC = () => {
  const { complaint } = useOutletContext<OutletContext>()

  if (!complaint) throw new Error('complaint not found')

  return (
    <Box gap="s40" height="full">
      <Box gap="s12" paddingRight="s24">
        <Text.Normal size="300" color="grey1000" weight="medium">
          {i18n.t('complaints.activity.write_response')}
        </Text.Normal>
        <NewMessage complaintId={complaint.id} blocked={complaint.blocked} />
      </Box>
      <Text.Normal size="200" color="grey700" weight="medium" caps>
        {i18n.t('complaints.tabs.messsages')}
      </Text.Normal>
      <Feed complaintId={complaint.id} />
    </Box>
  )
}

export default ComplaintActivity
